import { useCallback, useEffect, useState } from "react";

const KEY = "fb_guest_lang";

const ES = {
  "WELCOME! WHAT WOULD YOU LIKE TO DO?": "¡BIENVENIDO! ¿QUÉ TE GUSTARÍA HACER?",
  "Vote for Your Favorites": "Vota por tus favoritos",
  "Best table, costume and food. Scan your ticket to vote.": "Mejor mesa, traje y comida. Escanea tu boleto para votar.",
  "Recharge Your Drinks": "Recarga tus bebidas",
  "Scan your ticket barcode and pay by card.": "Escanea el código de tu boleto y paga con tarjeta.",
  "Need help or paying cash? Visit the Registration desk.": "¿Necesitas ayuda o pagas en efectivo? Visita la mesa de Registro.",
  "VOTE FOR YOUR FAVORITES": "VOTA POR TUS FAVORITOS",
  "Loading…": "Cargando…",
  "VOTING IS NOW CLOSED": "LA VOTACIÓN HA CERRADO",
  "Thank you for participating in Food Bazaar.": "Gracias por participar en Food Bazaar.",
  "Verify your ticket": "Verifica tu boleto",
  "Scan your Food Bazaar ticket barcode to vote": "Escanea el código de barras de tu boleto para votar",
  "Ticket barcode": "Código de barras del boleto",
  "Verify": "Verificar",
  "Stop Camera": "Detener cámara",
  "Scan Ticket Barcode": "Escanear código del boleto",
  "Voting as": "Votando como",
  "THANK YOU FOR VOTING!": "¡GRACIAS POR VOTAR!",
  "Your Food Bazaar votes have been submitted.": "Tus votos de Food Bazaar han sido enviados.",
  "Voted": "Votado",
  "Vote Now": "Vota ahora",
  "VOTE NOW": "VOTA AHORA",
  "You selected:": "Seleccionaste:",
  "GO BACK": "REGRESAR",
  "CONFIRM VOTE": "CONFIRMAR VOTO",
  "Vote submitted": "Voto enviado",
  "BEST TABLE DECORATION": "MEJOR DECORACIÓN DE MESA",
  "BEST TRADITIONAL COSTUME / DRESS": "MEJOR TRAJE / VESTIMENTA TRADICIONAL",
  "BEST FOOD": "MEJOR COMIDA",
  "Which country has the best table decoration?": "¿Qué país tiene la mejor decoración de mesa?",
  "Which country has the best traditional costume or dress?": "¿Qué país tiene el mejor traje o vestimenta tradicional?",
  "Which country has the best food?": "¿Qué país tiene la mejor comida?",
  "TICKET NOT FOUND": "BOLETO NO ENCONTRADO",
  "Enter Ticket Number Manually": "Ingresar número de boleto manualmente",
  "Ticket number": "Número de boleto",
  "Scan the barcode on your ticket": "Escanea el código de barras de tu boleto",
  "Continue": "Continuar",
  "Included drinks": "Bebidas incluidas",
  "Credit": "Crédito",
  "Credit added": "Crédito agregado",
  "Credit balance": "Saldo de crédito",
  "Ticket not found. Please check the number and try again.": "Boleto no encontrado. Revisa el número e inténtalo de nuevo.",
  "Enter your ticket number or scan the barcode.": "Ingresa tu número de boleto o escanea el código.",
  "Employee tickets are not eligible for additional drink purchases.": "Los boletos de empleado no pueden comprar bebidas adicionales.",
  "PLEASE SCAN THE BARCODE — THE TICKET NUMBER CAN'T BE USED TO VOTE": "ESCANEA EL CÓDIGO DE BARRAS — EL NÚMERO DEL BOLETO NO SIRVE PARA VOTAR",
  "TICKET NOT ELIGIBLE": "BOLETO NO ELEGIBLE",
  "THIS CATEGORY HAS ALREADY BEEN VOTED ON": "YA SE VOTÓ EN ESTA CATEGORÍA",
  "Invalid country": "País no válido",
  "RECHARGE YOUR DRINKS": "RECARGA TUS BEBIDAS",
  "1 · Ticket number": "1 · Número de boleto",
  "e.g. REG-02K4M9": "ej. REG-02K4M9",
  "2 · Scan the barcode on your ticket": "2 · Escanea el código de barras de tu boleto",
  "Scan barcode": "Escanear código",
  "Stop camera": "Detener cámara",
  "Camera not available. Please allow camera access or visit Registration.": "Cámara no disponible. Permite el acceso a la cámara o visita Registro.",
  "Ticket": "Boleto",
  "Drinks available": "Bebidas disponibles",
  "Beer": "Cerveza",
  "Cocktail": "Cóctel",
  "each": "c/u",
  "drink(s)": "bebida(s)",
  "max": "máx.",
  "Continue to payment": "Continuar al pago",
  "PAYMENT CONFIRMED": "PAGO CONFIRMADO",
  "Drinks purchased": "Bebidas compradas",
  "Amount paid": "Monto pagado",
  "Buy more drinks": "Comprar más bebidas",
  "Paying cash? Visit the Registration desk.": "¿Pagas en efectivo? Visita la mesa de Registro.",
  "← Back to guest portal": "← Volver al portal",
  "Cancel": "Cancelar",
  "PAY": "PAGAR",
  "Confirming your payment with Stripe…": "Confirmando tu pago con Stripe…",
  "Secure payment by Stripe. Your drinks are added after Stripe confirms the payment.": "Pago seguro con Stripe. Tus bebidas se agregan cuando Stripe confirma el pago.",
  "Payment failed. You were not charged.": "El pago falló. No se te cobró.",
  "Payment could not be completed. Please visit Registration.": "No se pudo completar el pago. Visita Registro.",
  "The ticket number and barcode don't match. Please try again.": "El número de boleto y el código no coinciden. Inténtalo de nuevo.",
  "Employee tickets can't be recharged.": "Los boletos de empleado no se pueden recargar.",
  "This ticket is not active. Please visit Registration.": "Este boleto no está activo. Visita Registro.",
  "Too many attempts. Please wait a few minutes and try again.": "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
  "Your session expired. Please verify your ticket again.": "Tu sesión expiró. Verifica tu boleto de nuevo.",
  "Choose at least one drink.": "Elige al menos una bebida.",
  "You can buy up to 10 drinks at a time.": "Puedes comprar hasta 10 bebidas a la vez.",
  "Card payments are not available right now.": "Los pagos con tarjeta no están disponibles ahora.",
};

const initial = () => {
  const saved = localStorage.getItem(KEY);
  if (saved === "en" || saved === "es") return saved;
  return (navigator.language || "en").toLowerCase().startsWith("es") ? "es" : "en";
};

export function useGuestLang() {
  const [lang, setLangState] = useState(initial);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = useCallback((l) => { localStorage.setItem(KEY, l); setLangState(l); }, []);
  const t = useCallback((s) => (lang === "es" && s && ES[s]) || s, [lang]);
  return { lang, setLang, t };
}

export function LangToggle({ lang, setLang }) {
  return (
    <div className="absolute top-4 right-4 z-20 flex rounded-full border border-slate-700 bg-[#131D33]/90 p-0.5 text-xs font-bold" data-testid="lang-toggle">
      {["en", "es"].map((l) => (
        <button key={l} onClick={() => setLang(l)} aria-pressed={lang === l}
          className={`px-3 py-1.5 rounded-full transition-colors ${lang === l ? "bg-orange-500 text-white" : "text-slate-300 hover:text-white"}`}
          data-testid={`lang-${l}`}>{l === "en" ? "EN" : "ES"}</button>
      ))}
    </div>
  );
}
